.pill-wrapper {
    display: flex;
    align-items: center;
    background-color: var(--blue-lt);
    border-radius: 20px;
    padding: 4px 8px;
}
